// extracted by mini-css-extract-plugin
export default {"fontVariation":"HeroSection_fontVariation__Gg42w","heroContainer":"HeroSection_heroContainer__SQAtC","heroContent":"HeroSection_heroContent__S8HAR"};